import OMT_UI_SettingsMenu from '../OMT_UI/Menus/Settings/OMT_UI_SettingsMenu';

G.UI_MapPanel = function (windowMgr) {

	Phaser.Group.call(this, game);

	this.fixedToCamera = true;
	this.cameraOffset.x = Math.floor(game.width * 0.5);


	this.bg = G.makeImage(0, 0, 'top-panel-bg', [0.5, 0], this);

	this.bg.inputEnabled = true;

	this.state = game.state.getCurrentState();

	var starsAmount = (G.saveState.getAllStars() - (this.state.lastLevelData ? this.state.lastLevelData.starImprovement : 0));

	this.starsIcon = new Phaser.Group(G.game, this);
	// let shadowDistance = 6;
	// let starShadow = G.makeImage(shadowDistance, shadowDistance, 'star', 0.5, this.starsIcon);
	// starShadow.tint = 0;
	// starShadow.alpha = 0.3;
	G.makeImage(0, 0, 'star', 0.5, this.starsIcon);
	this.starsIcon.x = G.OMTsettings.elements.UI_MapPanel.starsIcon.x;
	this.starsIcon.y = G.OMTsettings.elements.UI_MapPanel.starsIcon.y
	let starScale = 50 / this.starsIcon.height;
	this.starsIcon.scale.set(starScale, starScale);

	this.starsTxt = new G.Text(G.OMTsettings.elements.UI_MapPanel.starsTxt.x, G.OMTsettings.elements.UI_MapPanel.starsTxt.y, starsAmount.toString(), G.OMTsettings.elements.UI_MapPanel.starsTxt.style, [0, 0.5], 150);
	this.starsTxt.currentVal = (G.saveState.getAllStars() - (this.state.lastLevelData ? this.state.lastLevelData.starImprovement : 0));
	this.add(this.starsTxt);

	this.coinsBg = G.makeImage(G.OMTsettings.elements.UI_MapPanel.coinsBg.x, G.OMTsettings.elements.UI_MapPanel.coinsBg.y, 'top-panel-coinsBg', 0.5, this);

	this.coinsTxt = new G.Text(G.OMTsettings.elements.UI_MapPanel.coinsTxt.x, G.OMTsettings.elements.UI_MapPanel.coinsTxt.y, OMT.language.toLocaleNumber(G.saveState.getCoins()), G.OMTsettings.elements.UI_MapPanel.coinsTxt.style, 0.5, 95);
	this.coinsTxt.currentVal = G.saveState.getCoins() - (this.state.lastLevelData ? this.state.lastLevelData.reward : 0);
	this.add(this.coinsTxt);

	this.plusIcon = new G.Button(G.OMTsettings.elements.UI_MapPanel.plusIcon.x, G.OMTsettings.elements.UI_MapPanel.plusIcon.y, 'btn_plus', function () {
		G.Helpers.pushOutOfCoinsPopUp(false, { event: OMT.platformTracking.Events.OpenShopInventory }, false);
	}, this);
	this.plusIcon.hitArea = new Phaser.Rectangle(-200, -40, 230, 80);
	this.plusIcon.scale.setTo(0.9);
	this.add(this.plusIcon);

	this.lifeUI = new G.UI_Life(-260, 36);
	this.add(this.lifeUI);

	if (G.LIVES) {
		this.moveStarsTo(G.OMTsettings.elements.UI_MapPanel.moveTo.ifLifes.stars);
		this.moveCoinsTo(G.OMTsettings.elements.UI_MapPanel.moveTo.ifLifes.coins);
	} else {

		this.moveStarsTo(G.OMTsettings.elements.UI_MapPanel.moveTo.ifNotLifes.stars);
		this.moveCoinsTo(G.OMTsettings.elements.UI_MapPanel.moveTo.ifNotLifes.coins);
		this.lifeUI.visible = false;
	}

	if (!game.incentivised() && !G.IAP) {
		this.plusIcon.visible = false;
	}

	G.sb("turnOnIAP").add(function () {
		this.plusIcon.visible = true;
	}, this);

	// init the settings menu
	this.initSettingsMenu();

	G.sb("onScreenResize").add(this.onResize, this);
	G.sb("onWindowOpened").add(this.lockInput, this);
	G.sb("onAllWindowsClosed").add(this.unlockInput, this);
	G.sb("onStateChange").add(this.lockInput, this);
	G.sb("onCoinsChange").add(function (coins) {
		if (parseInt(this.coinsTxt.text) < coins) {
			G.sfx.coin_collect.play();
		}
		this.coinsTxt.setText(OMT.language.toLocaleNumber(coins));
	}, this);

	this.onResize();

};

G.UI_MapPanel.prototype = Object.create(Phaser.Group.prototype);

/**
 * initialize the expandable settings menu
 */
G.UI_MapPanel.prototype.initSettingsMenu = function () {
	const settingsMenu = new OMT_UI_SettingsMenu();
	settingsMenu.x = G.OMTsettings.elements.UI_MapPanel.settingsMenu.x;
	settingsMenu.y = G.OMTsettings.elements.UI_MapPanel.settingsMenu.y;
	settingsMenu.scale.set(G.OMTsettings.elements.UI_MapPanel.settingsMenu.scale);
	this.addChild(settingsMenu);
}

G.UI_MapPanel.prototype.lockInput = function () {
	this.ignoreChildInput = true;
};

G.UI_MapPanel.prototype.unlockInput = function () {
	this.ignoreChildInput = false;
};


G.UI_MapPanel.prototype.onResize = function () {
	this.cameraOffset.x = Math.floor(game.width * 0.5);
};

G.UI_MapPanel.prototype.moveStarsTo = function (x) {

	this.starsIcon.x = x;
	this.starsTxt.x = this.starsIcon.right + 8;

};

G.UI_MapPanel.prototype.moveCoinsTo = function (x) {

	this.coinsBg.x = x;
	this.coinsTxt.x = this.coinsBg.centerX + 15;

};
